// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import numeral from 'numeral';
import t from 'app/utils/translate';
import CurrencyIcon from 'app/components/commons/CurrencyIcon';

type Props = {
  darkMode: boolean,
  totalCost: number,
  numSelected: number
};

const Wrapper = styled.div(({ darkMode, theme }) => ({
  color: darkMode ? theme.color.basis6 : theme.color.invertableBasis6,
  display: 'flex',
  alignItems: 'center',
  padding: '1em',
  justifyContent: 'space-between',
  textTransform: 'uppercase',
  fontSize: '0.9em',
  backgroundColor: darkMode ? theme.color.darkBackground : theme.color.lightBackground
}));

const Highlight = styled.span(({ theme }) => ({
  color: theme.color.primary,
  paddingLeft: '0.2em'
}));

function LineUpFooter({ darkMode, numSelected, totalCost }: Props) {
  return (
    <Wrapper darkMode={darkMode}>
      <span>
        {t('Additional Entries')}:<Highlight>{numSelected}</Highlight>
      </span>
      <span>
        {t('Total buy-in')}:
        <Highlight>
          <CurrencyIcon />
          {numeral(totalCost).format('0,0.[00]')}
        </Highlight>
      </span>
    </Wrapper>
  );
}

function mapStateToProps(state) {
  return {
    darkMode: state.settings.darkMode
  };
}

export default connect(mapStateToProps)(LineUpFooter);
